import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Gasthreshold from '../entities/gasthreshold'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface GasthresholdState extends ListState<Gasthreshold>{
    editGasthreshold:Gasthreshold
}
class UserMutations extends ListMutations<Gasthreshold>{

}
class GasthresholdModule extends ListModule<GasthresholdState,any,Gasthreshold>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Gasthreshold>(),
        loading:false,
        editGasthreshold:new Gasthreshold()
    }
    actions={
        async getPage(context:ActionContext<GasthresholdState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Gasthreshold/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasthreshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<GasthresholdState,any>,payload:any){
            await Ajax.post('/api/services/app/Gasthreshold/Create',payload.data);
        },
        async update(context:ActionContext<GasthresholdState,any>,payload:any){
            await Ajax.put('/api/services/app/Gasthreshold/Update',payload.data);
        },
        async delete(context:ActionContext<GasthresholdState,any>,payload:any){
            await Ajax.delete('/api/services/app/Gasthreshold/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<GasthresholdState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Gasthreshold/GetById?Id='+payload.id);
            return reponse.data.result as Gasthreshold;
        },
        async RegetAll(context:ActionContext<GasthresholdState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Gasthreshold/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasthreshold>;
            context.state.totalCount=page.totalCount;
            // context.state.list=page.items;
            // context.state.filterlist=page.items;
            context.state.list=page.items;
        },
    };
    mutations={
        setCurrentPage(state:GasthresholdState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GasthresholdState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:GasthresholdState,gasthreshold:Gasthreshold){
            
            state.editGasthreshold=gasthreshold;
            //console.log(state.editFloor);
        }
    }
}
const gasthresholdModule=new GasthresholdModule();
export default gasthresholdModule;